import { RefreshNoticeCopy } from "./types";

export const REFRESH_NOTICE_COPY = {
  summary: {
    title: "Account summary couldn’t refresh",
    detail:
      "The latest saved totals are still shown. Check your connection and try again.",
  },
  summaryUnavailable: {
    title: "Account summary couldn’t load",
    detail:
      "Totals from the account record are shown until it loads. Check your connection and try again.",
  },
  history: {
    title: "Performance history couldn’t refresh",
    detail:
      "The chart still shows the last available series. Check your connection and try again.",
  },
  holdings: {
    title: "Holdings couldn’t refresh",
    detail:
      "Saved positions remain available. Your search, filters, sorting and page will stay in place.",
  },
  activity: {
    title: "Activity couldn’t refresh",
    detail:
      "Saved entries remain available. Your filters, sorting and page will stay in place.",
  },
  rail: {
    title: "Position insight couldn’t refresh",
    detail:
      "The current account or selected-position evidence is still shown. Check your connection and try again.",
  },
} satisfies Record<string, RefreshNoticeCopy>;

export const RETRYING_NOTICE_COPY = {
  title: "Refreshing latest data…",
  detail: "Saved data stays available while the connection is retried.",
  buttonLabel: "Refreshing…",
};

export const REFRESH_NOTICE_RETRY_LABEL = "Try again";
